var map = {
	"./text04_01.png": "1301",
	"./text04_02.png": "7212",
	"./text04_03.png": "68e6",
	"./text04_04.png": "eb92",
	"./text04_05.png": "4e70",
	"./text04_06.png": "a0a1",
	"./text04_07.png": "9536",
	"./text04_08.png": "d1eb",
	"./text04_09.png": "7334",
	"./text04_10.png": "54c0",
	"./text04_11.png": "2ccf",
	"./text04_12.png": "99bc",
	"./text04_13.png": "4209",
	"./text04_14.png": "bd57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ee7";